import React, { useState } from "react";
import { Table } from "antd";

const SkeletonTable = ({
  columns = [],
  data = [],
  isLoading,
  pagination = true,
  rowClassName = () => "",
  onRowClick = () => {},
  index = true,
}) => {
  const [paginationConfig, setPaginationConfig] = useState({
    current: 1,
    pageSize: 10,
  });

  const numberColumn = {
    title: "No.",
    dataIndex: "no",
    render: (_, __, index) => {
      const { current, pageSize } = paginationConfig;
      return (current - 1) * pageSize + index + 1;
    },
    width: 80,
  };

  const newColumns = index ? [numberColumn, ...columns] : columns;

  return (
    <Table
      className="table-responsive"
      columns={newColumns}
      dataSource={data}
      loading={isLoading}
      sortDirections={true}
      pagination={pagination}
      rowClassName={(record) => rowClassName(record)}
      onChange={(pagination) => {
        setPaginationConfig(pagination);
      }}
      onRow={(record) => {
        return {
          onClick: () => onRowClick(record),
          style: { cursor: 'pointer' }
        };
      }}
    />
  );
};

export default SkeletonTable;
